import React from 'react'
import { Typography, useTheme } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/pro-regular-svg-icons'
import LabraLogo from '../../../common/images/Labra.svg'
import { useStyles } from './StorefrontActivityLog.styles'

export const StorefrontActivityLog: React.FC = () => {
  const { classes } = useStyles()
  const theme = useTheme()
  return (
    <div className={classes.rootContainer}>
      <div className={classes.titleContainer}>
        <div className={classes.titleIconContainer} data-testid="heading-icon">
          <div className={classes.titleIcon}>
            <FontAwesomeIcon
              icon={faClock}
              style={{
                width: theme.spacing(2),
                height: theme.spacing(2),
              }}
            />
          </div>
        </div>
        <Typography className={classes.heading} data-testid="box-heading">
          Activity log
        </Typography>
      </div>
      <div className={classes.labraLogoContainer}>
        <img src={LabraLogo} alt="Labra Logo" className={classes.labraLogo} />
      </div>
    </div>
  )
}
